import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Evenements from "../pages/evenements/page";
import APropos from "../pages/a-propos/page";
import MenuPage from "../pages/menu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/a-propos",
    element: <APropos />,
  },
  {
    path: "/evenements",
    element: <Evenements />,
  },
  {
    path: "/menu",
    element: <MenuPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
